/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Compare_MacrosInputs */

const en_gc_resources_compare_macros = /** @type {(inputs: Gc_Resources_Compare_MacrosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VBA macros`)
};

const zh_gc_resources_compare_macros = /** @type {(inputs: Gc_Resources_Compare_MacrosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VBA 宏`)
};

/**
* | output |
* | --- |
* | "VBA macros" |
*
* @param {Gc_Resources_Compare_MacrosInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_compare_macros = /** @type {((inputs?: Gc_Resources_Compare_MacrosInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Compare_MacrosInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_compare_macros(inputs)
	return zh_gc_resources_compare_macros(inputs)
});
export { gc_resources_compare_macros as "gc.resources.compare.macros" }